import type { IClickmapSorted } from '@gem-sdk/heatmap-react';

import {
  EClickRankType,
  useHeatmapSettingContext,
  useHeatmapDataContext,
} from '@gem-sdk/heatmap-react';
import { useHeatmapAnalyticDeviceType, useHeatmapClickRankConfig } from '~/modules/heatmap/hooks';
import { formatMetricByFormatter } from '~/modules/analytics';
import { useConvertMoneyByCurrency } from '~/modules/shopify';
import { IMetricFormatter } from '~/modules/analytics/types';
import { GI18NText } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { Text } from '@shopify/polaris';

export const RankedMetricItem = ({ item }: { item: IClickmapSorted }) => {
  const rankedBy = useHeatmapSettingContext((state) => state.rankedBy);
  const dataInfo = useHeatmapDataContext((s) => s.dataInfo);
  const { data: deviceTypeData } = useHeatmapAnalyticDeviceType();
  const { getConfigById } = useHeatmapClickRankConfig();

  const { t } = useTranslation();
  const { getTextPrice } = useConvertMoneyByCurrency();

  const config = getConfigById(rankedBy ?? EClickRankType.MostClicks);
  const totalClicks = deviceTypeData?.totalClicks;
  const clickMapMetrics = dataInfo?.clickMapMetrics;
  const elementInfo = clickMapMetrics?.[item.hash];

  const metricValue = config.getMetric(elementInfo);

  const formattedValue = formatMetricByFormatter({
    value: metricValue,
    formatter: config.formatter,
    getTextPrice,
  });

  const percentage = formatMetricByFormatter({
    value: totalClicks ? metricValue / totalClicks : 0,
    formatter: IMetricFormatter.PERCENTAGE_STRING,
    getTextPrice,
  });

  return (
    <GI18NText
      as="p"
      variant="bodyMd"
      fontWeight="regular"
      truncate
      transformers={{
        1: (text) => (
          <Text as="span" variant="bodyMd" fontWeight="semibold">
            {text}
          </Text>
        ),
        2: (text) => {
          return (
            <Text as="span" variant="bodyMd" fontWeight="semibold">
              {text}
            </Text>
          );
        },
      }}
    >
      {t(config.template, {
        value: formattedValue,
        percentage,
      })}
    </GI18NText>
  );
};
